import api from '../service/api'
import { responseBuild } from "./utils";

const service = api;

export const getEstados = async () => {
    const request = await service.get(`/Estados`).then(responseBuild);
    return request
}